import { createCustomEnum } from "./customEnum";

const DocumentTypes = createCustomEnum({
	BankLetter: {
		value: 0,
		name: "BankLetter",
		displayName: "Bank Letter",
	},
	PhotoIdentification: {
		value: 1,
		name: "PhotoIdentification",
		displayName: "Photo Identification",
	},
	TaxReturn: {
		value: 2,
		name: "TaxReturn",
		displayName: "Tax Return",
	},
	BankStatement: {
		value: 3,
		name: "BankStatement",
		displayName: "Bank Statement",
	},
	VoidedCheck: {
		value: 4,
		name: "VoidedCheck",
		displayName: "Voided Check",
	},
	BusinessLicense: {
		value: 5,
		name: "BusinessLicense",
		displayName: "Business License",
	},
	UtilityBill: {
		value: 6,
		name: "UtilityBill",
		displayName: "Utility Bill",
	},
	PreviousProcessorStatements: {
		value: 7,
		name: "PreviousProcessorStatements",
		displayName: "Previous Processor Statements",
	},
	ApplicationUnredacted: {
		value: 8,
		name: "ApplicationUnredacted",
		displayName: "Application Unredacted",
	},
	OtherUnderwritingDocuments: {
		value: 9,
		name: "OtherUnderwritingDocuments",
		displayName: "Other Underwriting Documents",
	},
	EquipmentOrderingForm: {
		value: 10,
		name: "EquipmentOrderingForm",
		displayName: "Equipment Ordering Form",
	},
	UnderwritingDocument: {
		value: 11,
		name: "UnderwritingDocument",
		displayName: "Underwriting Document",
	},
	AgentContract: {
		value: 12,
		name: "AgentContract",
		displayName: "Agent Contract",
	},
	SignedScheduleA: {
		value: 13,
		name: "SignedScheduleA",
		displayName: "Signed Schedule A",
	},
	ResidualSplitprofileEmail: {
		value: 14,
		name: "ResidualSplitprofileEmail",
		displayName: "Residual Split Profile Email",
	},
	NailSoft: {
		value: 16,
		name: "NailSoft",
		displayName: "NailSoft Set Up",
	},
	Other: {
		value: 15,
		name: "Other",
		displayName: "Other",
	},
});

export default DocumentTypes;
